export default "__VITE_ASSET__Cvn53aaM__"